// 动态引入所有的svg
const requireAll = (requireContext: any) =>
  requireContext.keys().map(requireContext);

requireAll((require as any).context("./async-svgs", false, /\.svg$/));

export default {};
